import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import Select from '@mui/material/Select';
import UserTable from './UserTable';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import DeleteIcon from '@mui/icons-material/Delete';

const FindUser = () => {
  const [allUsers, setAllUsers] = useState([]);
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState('');

  const handleQuery = (e) => {
    setAllUsers([]);
    setInfo('');
    if (query.includes('@')) {
      getUserByEmail(query);
    } else if (query.length === 24) {
      getUserByID(query);
    } else {
      setInfo('Please enter a valid email or user ID.');
    }
  };
  const getUserByID = async (ID, options = {}) => {
    setLoading(true);
    setInfo('');
    if (!options.preserve) {
      setAllUsers([]);
    }
    try {
      const response = await axios({
        method: 'GET',
        url: `/api/v1/admin/getUserById/${ID}`,
      });
      setAllUsers([response.data.data.user]);
    } catch (err) {
      setAllUsers([]);
      setInfo(err.response.data.message);
      console.log('Error->', err.response.data.message);
    }
    setLoading(false);
  };
  const getUserByEmail = async (email, options = {}) => {
    setLoading(true);
    setInfo('');
    if (!options.preserve) {
      setAllUsers([]);
    }
    try {
      const response = await axios({
        method: 'GET',
        url: `/api/v1/admin/getUserByEmail/${email}`,
      });

      setAllUsers([response.data.data.user]);
    } catch (err) {
      setInfo(err.response.data.message);
      console.log('Error->', err.response.data.message);
    }
    setLoading(false);
  };
  const refreshUser = async () => {
    if (query.includes('@')) {
      await getUserByEmail(query, { preserve: true });
    } else if (query.length === 24) {
      await getUserByID(query, { preserve: true });
    }
  };

  return (
    <div className="adminUsers">
      <h1>Find User</h1>
      <div className="adminUsersSearch">
        <TextField
          id="outlined-basic"
          label="Type user email or user ID."
          variant="outlined"
          fullWidth
          sx={{ m: 1 }}
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
          }}
        />
      </div>
      <div className="adminUsersSearchButton">
        <Button variant="contained" onClick={handleQuery}>
          Search user
        </Button>
      </div>
      {loading && allUsers.length === 0 ? (
        <CircularProgress sx={{ m: 3 }} />
      ) : (
        allUsers.length > 0 && <UserTable allUsers={allUsers} onRefresh={refreshUser} />
      )}
      {loading && allUsers.length > 0 && <CircularProgress sx={{ m: 2 }} />}
      {info && <div className="AdminUserInfo">{info}</div>}
    </div>
  );
};

export default FindUser;
